import React from 'react';
import { string, object } from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';
import styles from './BenefitsBanner.css';

const cx = classnames.bind(styles);

const DescriptionItem = ({ description, icon, highlighted, title }) => {

  return (
    <div className={cx('itemWrapper', 'flex flex-column')}>
      { icon && <Icon customClasses={styles.icon} icon={icon.name} type={icon.type} /> }
      { title && <h5 className={cx('itemTitle', { 'v2': highlighted })}>
        {highlighted && <span className={cx('itemTitleHighlighted')}>{highlighted}</span>}
        &nbsp;{title}</h5>
      }
      <p className={styles.itemBody}>{description}</p>
    </div>
  );
};

DescriptionItem.displayName = 'BenefitsBannerDescriptionItem';

DescriptionItem.propTypes = {
  highlighted: string,
  title: string,
  icon: object,
  description: string.isRequired,
};

export default DescriptionItem;



// WEBPACK FOOTER //
// ./src/uis/components/Banner/BenefitsBanner/DescriptionItem.js